import React from 'react';
import { Router } from '@reach/router';

import Home from './home';
import Quiz from './quiz/main';
import Result from './result/main';

const App = () => {
  return (
    <Router basepath="/2022/04/dbti/">
      <Home path="/" />
      <Quiz path="/quiz" />
      <Result path="/result" />
    </Router>
  );
};

export default App
